const JobOpportunitiesDescription = ({
  info,
}) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: info }} className={"job-opportunities-description"} />
  );
};

export default JobOpportunitiesDescription;
